import { ShopifyProduct } from '@/lib/shopify';

export function getSkuString(
  shopifyProduct: ShopifyProduct | null | undefined,
) {
  if (!shopifyProduct) return '';
  return shopifyProduct?.variants.map((product) => product.sku).join(',');
}

/*
  Updated Locale/TS-IS mapping:
    - https://lovevery.atlassian.net/browse/SUBG-1062?focusedCommentId=85380
*/
export function getTrustedShopsId(locale: string) {
  const trustedShopsIds = {
    'en-GB': 'XF151ADC93CF66DA5764D64AB1BCFD1C7',
    'en-EU': 'X566BB887F94829872EE7BBFED0323F39',
    de: 'X571E1E7F766ABAFDE657BD5CC2A160F9',
    nl: 'XF8DFD54FC9F0CB59261864A9CF936260',
    fr: 'X97A22451D5CE823382C279422E071672',
    es: 'X64B76113E164F2B1751B97A61C38CCE1',
  };

  return trustedShopsIds[locale as keyof typeof trustedShopsIds];
}

export function getReviewsWidgetId(locale: string) {
  // Show EU-english reviews for all EU languages (per comment above)
  const widgetId_EU = 'wdg-9dffce9e-3e00-4080-b3a8-6bf406352821';
  const reviewsWidgetIds = {
    'en-GB': 'wdg-0c9c418e-44b6-4488-a55a-b7437905f65a',
    'en-EU': widgetId_EU,
    de: widgetId_EU,
    nl: widgetId_EU,
    fr: widgetId_EU,
    es: widgetId_EU,
  };

  const key = locale as keyof typeof reviewsWidgetIds;
  const widgetId = reviewsWidgetIds[key];
  return widgetId;
}

export function getShortRatingsWidgetId(locale: string) {
  // Show EU-english reviews for all EU languages (per comment above)
  const widgetId_EU = 'wdg-ede41b53-d976-40fa-b2cf-424434d169b7';

  const shortRatingsIds = {
    'en-GB': 'wdg-3e9b7d9b-1283-4c3c-9eb7-d3caf5793573',
    'en-EU': widgetId_EU,
    de: widgetId_EU,
    nl: widgetId_EU,
    fr: widgetId_EU,
    es: widgetId_EU,
  };

  const key = locale as keyof typeof shortRatingsIds;
  const widgetId = shortRatingsIds[key];
  return widgetId;
}

export function getLongRatingsWidgetId(locale: string) {
  // This is the overall Play Kit Program rating on the PLP
  // Show EU reviews for Spanish and German products (per comment above)
  const widgetId_EU = 'wdg-60048f9c-71ee-4a2e-a0ff-842ee83ae6cf';

  const longRatingsIds = {
    'en-GB': 'wdg-cad206fd-7ee5-40f8-8d9a-d8667d8ac390',
    'en-EU': widgetId_EU,
    de: widgetId_EU,
    nl: 'wdg-55139d17-5495-47bd-8201-ad2573c1dd5d',
    fr: 'wdg-4c26f199-5810-4c94-ad0e-6469f0dd172a',
    es: widgetId_EU,
  };

  const key = locale as keyof typeof longRatingsIds;
  const widgetId = longRatingsIds[key];
  return widgetId;
}
